/* tslint:disable */
/* eslint-disable */

/**
 * The environment's VoP mode:
 * - `off`: no VoP at all.
 * - `observe`: checks run and results show, but a payout neither
 *   waits for a result nor needs a VoP override.
 * - `enforce`: a payout needs a VoP result for its IBAN and name, and
 *   one other than a match needs a VoP override.
 */
export enum VopMode {
  Off = 'off',
  Observe = 'observe',
  Enforce = 'enforce'
}
